import { extractEmailAddress, IContact, validEmail } from "@sp-crm/core";

export const hasDeliverableAddress = (contact: IContact): boolean =>
    validEmail(extractEmailAddress(contact.email1 ?? ""));

export const undeliverableAddresses = (contacts: IContact[]): string[] =>
    Array.from(
        new Set(
            contacts
                .map(contact => (contact.email1 ?? "").trim())
                .filter(address => address.length > 0)
                .filter(address => !validEmail(extractEmailAddress(address))),
        ),
    );
